import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * Difusor de Fluxo (FML.DF) — painel próprio, 3 linhas SEM histograma:
 * DIFF ("DIFUSOR TAV") + DF− + DF+. yAccessor(d) retorna
 * { diff, dfMenos, dfMais }. Cores default = SetAttrs do engine
 * (DIFF #FF392B, DF− #FFAE16, DF+ #FFFFFF).
 */
class DifusorFluxoSeries extends Component {
  constructor(props) {
    super(props);
    this.diffAccessor = this.diffAccessor.bind(this);
    this.dfMenosAccessor = this.dfMenosAccessor.bind(this);
    this.dfMaisAccessor = this.dfMaisAccessor.bind(this);
  }
  diffAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.diff;
  }
  dfMenosAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.dfMenos;
  }
  dfMaisAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.dfMais;
  }
  render() {
    const { strokeDiff, strokeDfMenos, strokeDfMais, className } = this.props;
    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.diffAccessor}
          stroke={strokeDiff}
          fill="none"
        />
        <LineSeries
          yAccessor={this.dfMenosAccessor}
          stroke={strokeDfMenos}
          fill="none"
        />
        <LineSeries
          yAccessor={this.dfMaisAccessor}
          stroke={strokeDfMais}
          fill="none"
        />
      </g>
    );
  }
}

DifusorFluxoSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeDiff: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeDfMenos: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeDfMais: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

// Objetos (não strings): instâncias reidratadas de desktops importados perdem
// os strokes por-série no ensureValidAppearance e caem nestes defaults — o
// LineSeries lê stroke.color, então string aqui = linha invisível (mesmo
// padrão do WVADSeries/MACDSeries).
DifusorFluxoSeries.defaultProps = {
  strokeDiff: { color: "#FF392B", width: 2 },
  strokeDfMenos: { color: "#FFAE16", width: 2 },
  strokeDfMais: { color: "#FFFFFF", width: 2 },
  className: "react-stockcharts-difusor-fluxo",
};

export default DifusorFluxoSeries;
